<script setup lang="ts"></script>

<template>
    <div class="container my-12">
        <VInfobox
            variant="informative"
            title="Komponent ofertowy w MF"
            data-test="voice_offers_service_infobox"
        >
            <p class="paragraph-md">
                Znajdujesz się na stronie wygenerowanej przez MF. Docelowy komponent VoiceOffersService jest generowany
                generowany tylko przez eSHOP ARES.
            </p>
            <p class="paragraph-md">Aby przejść na docelową stronę wybierz odpowiedni link z menu.</p>
        </VInfobox>
    </div>
</template>

<style scoped></style>
